import React, { Fragment } from "react";
import { Listbox } from "@headlessui/react";
import { usePopper } from "react-popper";
import { FaFilter, FaCheck } from "react-icons/fa";
import { FilterProps } from "react-table";
import { mergeStyles } from "../../utilities/mergeStyles";

const AssessmentsTableFilterPriority: React.FC<
  FilterProps<Record<string, unknown>>
> = ({ column }) => {
  const priorities = [1, 2, 3, 4, 5, 6];

  const [referenceElement, setReferenceElement] =
    React.useState<HTMLButtonElement | null>(null);
  const [popperElement, setPopperElement] =
    React.useState<HTMLUListElement | null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "bottom-end",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
  });

  const onItemSelect = (item: number) => {
    if (column.filterValue === item) {
      column.setFilter(undefined);
    } else {
      column.setFilter(item);
    }
  };

  const selectedPriority = column.filterValue;

  return (
    <Listbox value={selectedPriority} onChange={onItemSelect}>
      <div className="relative">
        <Listbox.Label className="sr-only">Filter by service</Listbox.Label>
        <Listbox.Button
          ref={setReferenceElement}
          className={mergeStyles([
            "flex w-8 items-center justify-center pr-1 pt-2 pb-2 outline-none focus-visible:ring-2 focus-visible:ring-primary-400 rounded-md mr-1 mt-1 mb-1 hover:text-gray-500",
            column.filterValue !== undefined
              ? "text-gray-500"
              : "text-gray-300",
          ])}
          aria-label={`Filter by ${column.Header?.toString()}`}
        >
          <FaFilter></FaFilter>
        </Listbox.Button>
        <Listbox.Options
          ref={setPopperElement}
          style={styles.popper}
          className="z-10 bg-white shadow-lg max-h-60 rounded-md py-1 text-sm ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none w-56"
          {...attributes.popper}
        >
          {priorities.map((priority) => (
            <Listbox.Option
              key={priority}
              className={({ active }) =>
                mergeStyles([
                  active ? "text-white bg-primary-400" : "text-gray-500",
                  "cursor-default select-none flex py-2 pl-4 pr-4 justify-between",
                ])
              }
              value={priority}
            >
              {({ selected, active }) => (
                <>
                  <span
                    className={mergeStyles([
                      selected ? "font-semibold" : "font-normal",
                      "block truncate",
                    ])}
                  >
                    {priority}
                  </span>
                  {selected ? (
                    <span
                      className={mergeStyles([
                        active ? "text-white" : "text-primary-400",
                        "inset-y-0 left-0 flex items-center pl-1.5",
                      ])}
                    >
                      <FaCheck className="h-3 w-3" aria-hidden="true" />
                    </span>
                  ) : null}
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
};

export { AssessmentsTableFilterPriority };
